import { FC } from "react";

import PlayIcon from "../Icons/Play";

const PlayEffect: FC = () => {
  return (
    <div className="tuby-fade-zoom-out tuby-effect-icon">
      <PlayIcon className="tuby-icon-md" />
    </div>
  );
};

export default PlayEffect;
